/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DisputeResolutionOutcome = {
    UPHELD: 'UPHELD',
    REJECTED: 'REJECTED',
    SCORE_ADJUSTED: 'SCORE_ADJUSTED',
    MATCH_REPLAYED: 'MATCH_REPLAYED',
    TEAM1_FORFEIT: 'TEAM1_FORFEIT',
    TEAM2_FORFEIT: 'TEAM2_FORFEIT',
    DOUBLE_FORFEIT: 'DOUBLE_FORFEIT'
} as const;
export type DisputeResolutionOutcome = typeof DisputeResolutionOutcome[keyof typeof DisputeResolutionOutcome];


export function instanceOfDisputeResolutionOutcome(value: any): boolean {
    for (const key in DisputeResolutionOutcome) {
        if (Object.prototype.hasOwnProperty.call(DisputeResolutionOutcome, key)) {
            if (DisputeResolutionOutcome[key as keyof typeof DisputeResolutionOutcome] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DisputeResolutionOutcomeFromJSON(json: any): DisputeResolutionOutcome {
    return DisputeResolutionOutcomeFromJSONTyped(json, false);
}

export function DisputeResolutionOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeResolutionOutcome {
    return json as DisputeResolutionOutcome;
}

export function DisputeResolutionOutcomeToJSON(value?: DisputeResolutionOutcome | null): any {
    return value as any;
}

export function DisputeResolutionOutcomeToJSONTyped(value: any, ignoreDiscriminator: boolean): DisputeResolutionOutcome {
    return value as DisputeResolutionOutcome;
}

